import { lazy } from "react";

export const EmailSammelquittungDialog = lazy(() => import("./EmailSammelquittungDialog_"));
